import kconfig from '../app/config/kconfig';

const getBaseUrl = () => kconfig.backendBaseUrl;

export const api = {
  customers: (params = {}) => {
    return fetch(`${getBaseUrl()}/api/Customers/GetCustomerList`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    }).then(r => r.json());
  },
  patchCustomer: (customer_id, stage) =>
    fetch(`${getBaseUrl()}/api/Customers/Patch`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id, stage })
    }).then(r => r.json()),
  deleteCustomer: (customer_id) =>
    fetch(`${getBaseUrl()}/api/Customers/Delete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id })
    }).then(r => r.json()),
  conversations: (params = {}) =>
    fetch(`${getBaseUrl()}/api/Conversations/GetConversationList`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params)
    }).then(r => r.json()),
  deleteConversations: (customer_id) =>
    fetch(`${getBaseUrl()}/api/Conversations/Delete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id })
    }).then(r => r.json()),
  getChatMessage: (body) =>
    fetch(`${getBaseUrl()}/api/AiChatApp/GetChatMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(r => r.json()),
  sseUrl: (sessionId) => `${getBaseUrl()}/api/AiChatApp/GetSseStream/${sessionId}`,
  documents: (params = {}) => {
    const q = new URLSearchParams();
    if (params.industry != null) q.set('industry', params.industry);
    if (params.industry_id != null) q.set('industry_id', params.industry_id);
    if (params.limit != null) q.set('limit', params.limit);
    if (params.offset != null) q.set('offset', params.offset);
    return fetch(`${getBaseUrl()}/api/Documents?${q}`).then(r => r.json());
  },
  /**
   * GET biz_document_usage_log 列表。
   * 用途1：上半部分右侧 - 传 document_id 取某条知识库记录的关联使用日志。
   * 用途2：下半部分 - 传 industry_id（可选）取全表日志，按 created_at 倒序。
   */
  documentUsageLogs: (params = {}) => {
    const q = new URLSearchParams();
    if (params.document_id != null) q.set('document_id', params.document_id);
    if (params.industry != null) q.set('industry', params.industry);
    if (params.industry_id != null) q.set('industry_id', params.industry_id);
    if (params.limit != null) q.set('limit', params.limit);
    if (params.offset != null) q.set('offset', params.offset);
    return fetch(`${getBaseUrl()}/api/DocumentUsageLog?${q}`).then(r => r.json());
  }
};
